import Raven from 'raven-js'
import guestLayers from '../config/guestLayers'

const getLayersFromJwt = jwt => {
  if (!jwt) {
    Raven.captureMessage('jwt is null', {
      jwt
    })
    return guestLayers
  }
  const namespace = 'https://auth0.looknorthservices.com/v1/'
  const permissions = jwt[namespace + 'permissions']
  if (!permissions || !permissions.coresight2 || ! permissions.coresight2.projects) {
    Raven.captureMessage('jwt is malformed', {
      jwt
    })
    return guestLayers
  }
  const projects = permissions.coresight2.projects
  const layerArrays = Object.keys(projects).map(key =>
    Object.keys(projects[key].layers).map(key => key)
  )
  const layers = [].concat.apply([], layerArrays)

  return layers
}

export default getLayersFromJwt



// WEBPACK FOOTER //
// ./src/utility/getLayersFromJwt.js